<div class="d-flex justify-content-between p-12">
    <h2 mat-dialog-title class="p-0 m-0">
        Report sullo score
    </h2>
    <div>
        <i-tabler name="x" (click)="close()" class="icon-20 cursor-pointer"></i-tabler>
    </div>
</div>
<mat-dialog-content>  
    <div class="score-report bg-error">
        <span class="f-s-18">Consumi</span>
        <h5 class="f-s-14 m-0 f-w-400 p-b-10">
            La quota della produzione intercetta solo il 15% dei consumi.<br>
            Verificare la classifica di produzione e le abitudini.
        </h5>
    </div>
    <div class="score-report bg-warning">
        <span class="f-s-18">Produzione</span>
        <h5 class="f-s-14 m-0 f-w-400 p-b-10">
            Il potenziale di produzione è 890 Kw/h ma la CER sta producendo soltanto 130 Kw/h.<br>
            Verificare gli impianti.
        </h5>
    </div>
</mat-dialog-content>